import PageHeader from "@/components/site/PageHeader";
import { PrayerRequest } from "@/components/site/Forms";
import { CTABand } from "@/components/site/AboutSections";
import { usePageMeta } from "@/lib/usePageMeta";

export default function PrayerPage() {
  usePageMeta(
    "Prayer Request",
    "Submit a prayer request to the RE//FORM PLACE CHI intercessory prayer team. Confidential, Spirit-led, and standing with you.",
  );
  return (
    <div data-testid="prayer-page">
      <PageHeader
        crumb="Prayer"
        eyebrow="Prayer"
        title="We Will"
        accent="Stand With You"
        intro="Our intercessory prayer team led by Prophet Dr. A. Cecilia Beasley prays over every request we receive. Nothing is too small."
        image="/outreach/prayer-on-street.webp"
        imagePosition="center 30%"
      />
      <PrayerRequest />
      <CTABand
        eyebrow="Encounter"
        title="Fire Nights · 2nd Thursdays"
        text="Prayer, presence, and encounter. Come expecting God to move."
        primary={{ to: "/events", label: "See Gatherings" }}
        secondary={{ to: "/watch", label: "Watch Online" }}
      />
    </div>
  );
}
